import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import SearchInput from "../../../../components/inputs/searchInput";
import { useServicesCRM } from "../context/getCRM";
import ModalFilter from "./buttons/filter";

interface HeaderCRMProps {

}

const HeaderCRM: FunctionComponent<HeaderCRMProps> = () => {

  const { listAll, getSearchMinister } = useServicesCRM()

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll, ['usuario', 'nome', 'pg', 'batismo', 'checkin', 'cursolider'])}
          callDownloadPdf={() => DonwloadPdf(listAll, ['Id', 'Nome', 'Célula', 'Batismo', 'Checkin', 'Curso'],
            ['usuario', 'nome', 'pg', 'batismo', 'checkin', 'cursolider'], listAll?.length, [], `${listAll?.length}`)
          }
        />

        <ModalFilter />

      </section>

      <SearchInput
        placeholder="Procure por Nome"
        onChange={getSearchMinister}
      />

    </SecaoButao>
  </>);
}

export default HeaderCRM;
